module.exports = __webpack_public_path__ + "static/img/img3.57e1855.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img3.jpg
// module id = DjEO
// module chunks = 0